import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartridgeOverviewInfo } from '@markant-platform/shared/organization/model';
import { UsageRightActivationState } from '@markant-platform/usage-right/model';
import { Page } from '@markant-platform/shared/data-access';
import { SharedOrganizationFeatureModule } from '@markant-platform/shared/organization/feature';
import { BackofficeOrganizationBookingsTableComponent } from '@markant-platform/backoffice/feature-organization-bookings';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoService } from '@jsverse/transloco';
import { ArrayIncludesPipe } from '@markant-platform/shared/util-pipes';

@Component({
  selector: 'markant-platform-bookings-table-demo',
  standalone: true,
  imports: [
    CommonModule,
    SharedOrganizationFeatureModule,
    BackofficeOrganizationBookingsTableComponent,
    MarkantElementsModule,
    ArrayIncludesPipe,
  ],
  templateUrl: './bookings-table-demo.component.html',
  styleUrl: './bookings-table-demo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingsTableDemoComponent {
  @Input() currentStep!: number;

  baseKey = 'guidedTour.tours.guided-tour-oa-admin-area.section4.step9';

  private readonly translocoService = inject(TranslocoService);

  readonly DEMO_SCREEN_STEPS = [10, 11];
  readonly demoBookings: Page<CartridgeOverviewInfo> = {
    hasNext: true,
    pageIndex: 1,
    pageSize: 10,
    totalCount: 8,
    result: [
      {
        id: '1',
        name: this.translocoService.translate(`${this.baseKey}.serviceName1`),
        description: '',
        usageRightActivationState: UsageRightActivationState.ACTIVE,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        workflowFinishedAt: '2023-07-27',
        bookingStartedAt: '2023-07-27',
      },
      {
        id: '2',
        name: this.translocoService.translate(`${this.baseKey}.serviceName2`),
        description: '',
        usageRightActivationState: UsageRightActivationState.ACTIVE,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        bookingStartedAt: '2023-07-27',
        workflowFinishedAt: '2023-07-27',
      },
      {
        id: '3',
        name: this.translocoService.translate(`${this.baseKey}.serviceName3`),
        description: '',
        usageRightActivationState: UsageRightActivationState.ACTIVE,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        workflowFinishedAt: '2023-07-27',
        bookingStartedAt: '2023-07-27',
      },
      {
        id: '4',
        name: this.translocoService.translate(`${this.baseKey}.serviceName4`),
        description: '',
        usageRightActivationState: UsageRightActivationState.PENDING,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        bookingStartedAt: undefined,
        workflowFinishedAt: undefined,
      },
      {
        id: '5',
        name: this.translocoService.translate(`${this.baseKey}.serviceName5`),
        description: '',
        usageRightActivationState: UsageRightActivationState.ACTIVE,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        workflowFinishedAt: '2023-07-27',
        bookingStartedAt: '2023-07-27',
      },
      {
        id: '6',
        name: this.translocoService.translate(`${this.baseKey}.serviceName6`),
        description: '',
        usageRightActivationState: UsageRightActivationState.PENDING,
        serviceManager: 'Franziska Schneider',
        bookingDate: '2023-07-27',
        workflowFinishedAt: undefined,
        bookingStartedAt: undefined,
      },
    ],
  };

  activeFilters: Record<string, string[]> = {
    state: ['ACTIVE', 'PENDING'],
  };
}
